module.exports = __webpack_public_path__ + "static/media/check.ddee2f5e.svg";